import React, { memo, useEffect, useRef, useState } from 'react';
import { Card, Tab } from 'react-bootstrap';
import { useClickAway } from 'react-use';
import { useGetRequest } from '../../../hooks/useGetRequest';
import { MEDICINE_TYPES_SHORTS, getMedicineIcon } from '../../../utils/helpers';
import FormatsAndType from '../partials/rx/formatsAndType';
import Information from '../partials/rx/information';
import SimilarMedicine from '../partials/rx/similarMedicine';
import Suggestions from '../partials/suggestions';
import TabNavMedicineDefault from '../partials/tabNavMedicineDefault';

const MedicineBrandListModal = ({
  item,
  removeSchedule,
  duplicateSchedule,
  handleDefaultData,
  setIsMedicineDefault,
  handleSelectedMedicine,
  showBrandListModal,
  setShowBrandListModal,
  setShowScheduleListModal,
  setClickedItemForScheduleList,
  showMedicineName,
  handleClickOnRightArrow,
}) => {
  const onRightArrowClick = (e, medicine) => {
    const rect = ref.current?.getBoundingClientRect();
    const topRem = e.clientY / 16;
    const leftRem = rect ? (rect.right + 5) / 16 : undefined;
    handleClickOnRightArrow?.(e, medicine, topRem, leftRem);
  };
  const [indications, setIndications] = useState(null);
  const ref = useRef(null);

  const { isLoading, refetch: getMedicineIndication } = useGetRequest(
    `getMedicineIndication-${item?.id}`,
    `medicine-indications/${item?.medicineIndicationId}`,
    (data) => {
      const banglaResult = Object.keys(data)
        .filter((key) => key.endsWith('Bn') && data[key].details !== '')
        .map((key) => data[key])
        .sort((a, b) => a.sort - b.sort);

      const englishResult = Object.keys(data)
        .filter((key) => !key.endsWith('Bn') && data[key].details !== '')
        .map((key) => data[key])
        .sort((a, b) => a.sort - b.sort);
      const result = { banglaResult, englishResult };
      setIndications({ ...result });
    },
    (e) => {
      console.log(e);
    },
  );

  useClickAway(ref, (e) => {
    setShowBrandListModal(false);
    setShowScheduleListModal(false);
  });

  useEffect(() => {
    if (item?.medicineIndicationId) {
      getMedicineIndication();
    }
  }, [item?.medicineIndicationId]);

  const handleSelectedMedicineAndClose = (...args) => {
    handleSelectedMedicine(...args);
    setShowBrandListModal(false);
    setShowScheduleListModal(false);
  };

  return (
    <Card
      className="medicine-default testt-modal"
      ref={ref}
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1060,
        width: '420px',
        maxHeight: '80vh',
        overflowY: 'auto',
      }}
    >
      <Card.Header>
        <div className="medicine-name-and-icon">
          <img
            src={getMedicineIcon(MEDICINE_TYPES_SHORTS[item.type])}
            alt="Tablet"
            className="pr-2"
            width={40}
            height={36}
          />
          <span className="medicine-name">
            {MEDICINE_TYPES_SHORTS[item.type]} {item?.name}
          </span>
          <span>
            <i
              onClick={() => setShowBrandListModal(false)}
              className="fa fa-times-circle"
              aria-hidden="true"
            ></i>
          </span>
        </div>
        <div className="generic-name">{item?.genericName}</div>
      </Card.Header>
      <Card.Body>
        <Tab.Container id="left-tabs" defaultActiveKey="suggestions">
          {/* <TabNavMedicineDefault /> */}
          <Tab.Content>
            {/* <Tab.Pane eventKey="suggestions" className="add-scroll">
              <Suggestions
                medicine={item}
                handleDefaultData={handleDefaultData}
              />
            </Tab.Pane> */}
            {/* <Tab.Pane
              eventKey="similarMedicines"
              className="add-scroll similar-medicine"
            > */}
            <div className="add-scroll similar-medicine">
              <SimilarMedicine
                item={item}
                handleSelectedMedicine={handleSelectedMedicineAndClose}
                setShowScheduleListModal={setShowScheduleListModal}
                setClickedItemForScheduleList={setClickedItemForScheduleList}
                showMedicineName={showMedicineName}
                handleClickOnRightArrow={onRightArrowClick}
              />
            </div>
            {/* </Tab.Pane> */}
            {/* <Tab.Pane eventKey="formatsAndType" className="formats-type">
              <FormatsAndType
                medicine={item}
                removeSchedule={removeSchedule}
                duplicateSchedule={duplicateSchedule}
                handleSelectedMedicine={handleSelectedMedicine}
              />
            </Tab.Pane> */}
            {/* <Tab.Pane eventKey="information" className="add-scroll information">
              <Information indications={indications} />
            </Tab.Pane> */}
          </Tab.Content>
        </Tab.Container>
      </Card.Body>
      <Card.Footer>
        Manufacturer: <span>{item?.companyName}</span>
      </Card.Footer>
    </Card>
  );
};

export default memo(MedicineBrandListModal);
